/**
 * @fileoverview gRPC-Web generated client stub for 
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.20.3
// source: adminbackendproto/AdminNewsletterService.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as adminbackendproto_AdminNewsletterService_pb from '../adminbackendproto/AdminNewsletterService_pb'; // proto import: "adminbackendproto/AdminNewsletterService.proto"


export class AdminNewsletterServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorListNewslettersForReview = new grpcWeb.MethodDescriptor(
    '/AdminNewsletterService/ListNewslettersForReview',
    grpcWeb.MethodType.UNARY,
    adminbackendproto_AdminNewsletterService_pb.ListNewslettersForReviewRequest,
    adminbackendproto_AdminNewsletterService_pb.ListNewslettersForReviewResponse,
    (request: adminbackendproto_AdminNewsletterService_pb.ListNewslettersForReviewRequest) => {
      return request.serializeBinary();
    },
    adminbackendproto_AdminNewsletterService_pb.ListNewslettersForReviewResponse.deserializeBinary
  );

  listNewslettersForReview(
    request: adminbackendproto_AdminNewsletterService_pb.ListNewslettersForReviewRequest,
    metadata?: grpcWeb.Metadata | null): Promise<adminbackendproto_AdminNewsletterService_pb.ListNewslettersForReviewResponse>;

  listNewslettersForReview(
    request: adminbackendproto_AdminNewsletterService_pb.ListNewslettersForReviewRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: adminbackendproto_AdminNewsletterService_pb.ListNewslettersForReviewResponse) => void): grpcWeb.ClientReadableStream<adminbackendproto_AdminNewsletterService_pb.ListNewslettersForReviewResponse>;

  listNewslettersForReview(
    request: adminbackendproto_AdminNewsletterService_pb.ListNewslettersForReviewRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: adminbackendproto_AdminNewsletterService_pb.ListNewslettersForReviewResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/AdminNewsletterService/ListNewslettersForReview',
        request,
        metadata || {},
        this.methodDescriptorListNewslettersForReview,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/AdminNewsletterService/ListNewslettersForReview',
    request,
    metadata || {},
    this.methodDescriptorListNewslettersForReview);
  }

  methodDescriptorReviewNewsletter = new grpcWeb.MethodDescriptor(
    '/AdminNewsletterService/ReviewNewsletter',
    grpcWeb.MethodType.UNARY,
    adminbackendproto_AdminNewsletterService_pb.ReviewNewsletterRequest,
    adminbackendproto_AdminNewsletterService_pb.ReviewNewsletterResponse,
    (request: adminbackendproto_AdminNewsletterService_pb.ReviewNewsletterRequest) => {
      return request.serializeBinary();
    },
    adminbackendproto_AdminNewsletterService_pb.ReviewNewsletterResponse.deserializeBinary
  );

  reviewNewsletter(
    request: adminbackendproto_AdminNewsletterService_pb.ReviewNewsletterRequest,
    metadata?: grpcWeb.Metadata | null): Promise<adminbackendproto_AdminNewsletterService_pb.ReviewNewsletterResponse>;

  reviewNewsletter(
    request: adminbackendproto_AdminNewsletterService_pb.ReviewNewsletterRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: adminbackendproto_AdminNewsletterService_pb.ReviewNewsletterResponse) => void): grpcWeb.ClientReadableStream<adminbackendproto_AdminNewsletterService_pb.ReviewNewsletterResponse>;

  reviewNewsletter(
    request: adminbackendproto_AdminNewsletterService_pb.ReviewNewsletterRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: adminbackendproto_AdminNewsletterService_pb.ReviewNewsletterResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/AdminNewsletterService/ReviewNewsletter',
        request,
        metadata || {},
        this.methodDescriptorReviewNewsletter,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/AdminNewsletterService/ReviewNewsletter',
    request,
    metadata || {},
    this.methodDescriptorReviewNewsletter);
  }

  methodDescriptorRegenerateNewsletter = new grpcWeb.MethodDescriptor(
    '/AdminNewsletterService/RegenerateNewsletter',
    grpcWeb.MethodType.UNARY,
    adminbackendproto_AdminNewsletterService_pb.RegenerateNewsletterRequest,
    adminbackendproto_AdminNewsletterService_pb.RegenerateNewsletterResponse,
    (request: adminbackendproto_AdminNewsletterService_pb.RegenerateNewsletterRequest) => {
      return request.serializeBinary();
    },
    adminbackendproto_AdminNewsletterService_pb.RegenerateNewsletterResponse.deserializeBinary
  );

  regenerateNewsletter(
    request: adminbackendproto_AdminNewsletterService_pb.RegenerateNewsletterRequest,
    metadata?: grpcWeb.Metadata | null): Promise<adminbackendproto_AdminNewsletterService_pb.RegenerateNewsletterResponse>;

  regenerateNewsletter(
    request: adminbackendproto_AdminNewsletterService_pb.RegenerateNewsletterRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: adminbackendproto_AdminNewsletterService_pb.RegenerateNewsletterResponse) => void): grpcWeb.ClientReadableStream<adminbackendproto_AdminNewsletterService_pb.RegenerateNewsletterResponse>;

  regenerateNewsletter(
    request: adminbackendproto_AdminNewsletterService_pb.RegenerateNewsletterRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: adminbackendproto_AdminNewsletterService_pb.RegenerateNewsletterResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/AdminNewsletterService/RegenerateNewsletter',
        request,
        metadata || {},
        this.methodDescriptorRegenerateNewsletter,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/AdminNewsletterService/RegenerateNewsletter',
    request,
    metadata || {},
    this.methodDescriptorRegenerateNewsletter);
  }

}

